import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { map } from "lodash";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

import ClickToCopy from "./ClickToCopy";
import { FlexBox } from "./FlexBox";

export default function ReadOnlyClickToCopyList({
  listData,
}: {
  listData: { label: string; value: string | null; noCopy?: boolean }[];
}): ReactElement {
  return (
    <List sx={{ maxWidth: "100%" }}>
      {map(listData, ({ label, value, noCopy }) => {
        return (
          <ListItem
            key={label}
            sx={{
              p: 0,
              pr: "8px",
              mb: "16px",
              borderColor: palette.blue,
              borderWidth: "1px",
              borderRadius: "4px",
              borderStyle: "solid",
            }}
          >
            <ListItemIcon>
              {noCopy ? null : (
                <FlexBox alignItems="center">
                  <ClickToCopy
                    text={value || ""}
                    iconSx={{ color: palette.blue }}
                  >
                    &nbsp;
                  </ClickToCopy>
                  <Typography
                    variant="body2Bold"
                    component={"div"}
                    marginRight={"10px"}
                    color={palette.navy}
                  >
                    <strong>{label}</strong>:
                  </Typography>
                </FlexBox>
              )}
            </ListItemIcon>
            <ListItemText id={label}>
              <Typography noWrap color={palette.blue} component={"div"}>
                {value}
              </Typography>
            </ListItemText>
          </ListItem>
        );
      })}
    </List>
  );
}
